import React from "react";

const StoreIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
            <path
                fill="#002856"
                d="M3.334 2a.667.667 0 0 0-.667.667v2L1.334 8v1.333h.667v3.334C2 13.395 2.605 14 3.334 14h9.333c.729 0 1.334-.605 1.334-1.333V9.333h.666V8l-1.333-3.333v-2A.667.667 0 0 0 12.667 2H3.334Zm.667 1.333h8v1.59L13.23 8H2.771L4 4.923v-1.59ZM5.334 4a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm2 0a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm-4 5.333h9.333v3.334H3.334V9.333Z"
            />
        </svg>
    );
};

export default StoreIcon;
